<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;background-color: #fff;">
			<div class="headerBox">
				<div class="hearderContentBox">
					<div class="titleBox">
						<div class="logoBox">
							<img :src="getImg(all_logo)" alt="">
						</div>
						<span style="margin-left: 10px;">{{ platformName }}</span>
					</div>
					<div class="rightBox" v-if="user.phoneNumber">
						<a-dropdown>
							<template #overlay>
								<a-menu style="margin-top:-30px">
									<a-menu-item key="3">
										<a @click="onLogout()">
											<PoweroffOutlined /> 退出登录
										</a>
									</a-menu-item>
								</a-menu>
							</template>
							<a class="ant-dropdown-link" style="margin-left:20px;position:relative;padding:0 10px 0 10px"
								@click="islogin">
								<img style="position:absolute; left:-9px; top:38px" src="@/assets/img/login.png" alt=""> {{
									user.phoneNumber
								}}
							</a>
						</a-dropdown>

					</div>
					<div class="rightBox" v-else>
						<div class="loginBox">
							<img src="@/assets/img/login.png" />
							<!-- <a-dropdown> -->
							<span @click="goMore('/login', 'user')" style="margin-left: 10px;">登录</span>
							<!-- <template #overlay>
                                      <a-menu>
                                          <a-menu-item>
                                              <span @click="goMore('/login', 'manage')">管理员</span>
                                          </a-menu-item>
                                          <a-menu-item>
                                              <span @click="goMore('/login', 'user')">普通用户</span>
                                          </a-menu-item>
                                      </a-menu>
                                  </template> -->
							<!-- </a-dropdown> -->
						</div>
						<a-divider class="lineBox" type="vertical" />
						<div class="resigierBox" @click="this.$router.push('/register')">注册</div>
					</div>

					<div class="rightBox" style="margin-right:20px">

						<a-dropdown>
							<template #overlay>
								<a-menu style="margin-top:-30px">
									<a-menu-item @click="goMore('/Innovation/index')" key="2">
										创新创业
									</a-menu-item>
									<a-menu-item @click="goMore('/finance/index')" key="3">
										科技金融
									</a-menu-item>
									<a-menu-item @click="goMore('/knowledge/index')" key="4">
										知识产权
									</a-menu-item>
									<a-menu-item @click="goMore('/EducationService/index')" key="5">
										科技人才
									</a-menu-item>
									<a-menu-item @click="goMore('/achievements/index')" key="6">
										成果转化
									</a-menu-item>
								</a-menu>
							</template>
							<a class="ant-dropdown-link" @click="goMore('/')">
								<!-- <HomeOutlined />  -->
								首页
								<DownOutlined />
							</a>
						</a-dropdown>
					</div>
				</div>
			</div>

		</div>
		<div style="width: 100%;background-color: #fff;margin-bottom: 40px;">
			<div class="floatBox">
				<div class="textBox">
					<div class="text">注册审核状态</div>
				</div>
				<div class="midBox">
					<div class="midFloatBox">
						<div class="breadBox">
							<a-breadcrumb>
								<span style="font-size: 14px;">
									<img src="@/assets/img/position.png" />
									当前位置：
								</span>
								<a-breadcrumb-item style="cursor: pointer;color: #0a87bf;font-size: 14px;"
									@click="this.$router.push('/')">首页</a-breadcrumb-item>
								<a-breadcrumb-item style="font-size: 14px;">注册审核状态</a-breadcrumb-item>
							</a-breadcrumb>
						</div>

						<div class="tabBox">
							<a-form class="login-form" ref="ruleForm" layout="horizontal" :model="form" :rules="rules">
								
								<a-form-item  :label-col="{style:'width:90px'}" name="phoneNumber" label="账号">
									<a-input size="large" style="width:100%" v-model:value="form.phoneNumber" placeholder="请输入手机号">
										<template #prefix>
											<PhoneOutlined class="tc-gray" />
										</template>
									</a-input>
								</a-form-item>
								<a-form-item :label-col="{style:'width:90px'}" style="margin-top:20px" name="remark" label="验证码">
									<a-input size="large" placeholder="请输入验证码" v-model:value="inputvalue">
										<template #prefix>
											<LockOutlined class="tc-gray" />
										</template>
										<template #suffix>
											<div class="code" @click="clearCode()">{{ code }}</div>
										</template>
									</a-input>
									<span v-if="this.show" style="color: red">请输入验证码</span>
									<span v-if="this.showerror" style="color: red">验证码输入有误</span>
								</a-form-item>
								
								<div style="overflow: hidden;margin-top: 30px;">
									<div class="btnBB">
										<a-button size="large" style="margin-right: 20px;" @click="goMore('/login', 'user')">返回登录</a-button>
										<a-button size="large" style="width: 96px" type="primary" html-type="submit" :loading="confirmLoading"
											@click="onSubmit">
											查询
										</a-button>
									</div>
								</div>
								<!-- <div style="margin-top: 20px">
									<a-button size="large" type="primary" html-type="submit" block :loading="confirmLoading"
										@click="onSubmit">
										立即注册
									</a-button>
									<div style="overflow: hidden;margin-top: 10px;">
										<p style="float:left">
											<a @click="this.$router.push('/')">返回首页</a>
										</p>
										<p style="float:right">
											已有账户？请<a @click="goMore('/login', 'user')"> 登录</a>
										</p>
									</div>
								</div> -->
							</a-form>
						</div>
					</div>
				</div>
			</div>
		</div>
		<LayoutFooter />
	</div>
</template>
  
<script>
import { dictMixin } from "@/mixins";
import { login_mp } from "@/api/adminService";
import { ls } from "@/utils/util"
import { enterpriseOperatingIncome } from "@/api/integral";
import { sys_admin, file_service } from "@/api/adminService";
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import axios from "axios";
import dataCheck from "@/utils/dataCheck";
import { register_mp } from "@/api/adminService";
import { common } from "@/api/finance"
import { notification } from "ant-design-vue";

export default {
	name: "index",
	components: {
		LayoutFooter,
	},
	mixins: [dictMixin],
	data() {
		return {
			all_logo: '',
			dictNames: 'policy_type',
			user: {},
			getDateId: null,
			formState: {
				user: undefined,
			},
			webSiteInfo: {},
			linkData: [],
			pwOk: null,
			companyShow: null,
			optionsRoleTreeList: null,
			optionsMechanIsmTreeList: null,
			optionsBaseTreeTreeList: null,
			optionsTreeList: null,
			code: '',
			codeLength: 4,
			inputvalue: '',
			show: false,
			showerror: false,
			platformName,
			confirmLoading: false,
			form: {
				phoneNumber: null,
				// captcha: null,
			},
			rules: {
				phoneNumber: [
					dataCheck.required({ msg: '手机号不能为空' }), dataCheck.mobile_phone
				],
				// captcha: [
				//     dataCheck.required({msg: '验证码不能为空'}),
				// ],
			},
			captchaPath: '',
			redirectPath: '/',
		}
	},
	methods: {
		logout() {
			let self = this;

			self.$ls.clear();
			self.$store.commit('setMenuData', []);
			self.$router.replace('/');

			location.reload();
		},
		onLogout() {
			let self = this;
			self.$confirm({
				title: '确认要退出登录?',
				content: '',
				onOk() {
					self.postAction({
						url: login_mp.saveLog,
						params: { logAppCategoryEnum: "LOGOUT" }
					}).then(res => {
						console.log(res)
						self.getAction({
							url: login_mp.logout,
							params: { access_token: ls.get("token") || "" },
							isValid: false
						}).then(() => {
							self.$notification['success']({
								message: '退出成功',
                                style: {
                                    fontWeight: '600',
                                },
							});
						})
					})


					setTimeout(() => {
						self.logout();
					}, 2000)
				},
				onCancel() {
				},
			});
		},
		getUserInfo() {
			this.getAction({
				url: sys_admin.userInfor
			}).then(res => {
				sessionStorage.setItem("roleCode", res.roleCode.split(','));
			})
		},
		goHttp(url) {
			window.open(url, '_bank')
		},
    islogin() {
      if (ls.get("token") && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else {
          this.goMore('/sys/userInfo')
        }
      } else {
        this.goMore('/login', 'user')
      }
    },
		goMore(url, str) {
			this.$router.push({ path: url, query: { id: str } })
		},
		getDate() {
			this.getAction({
				url: enterpriseOperatingIncome.getDate,
				// params: { id: id },
				returnMsg: true,
			}).then((res) => {
				this.getDateId = res.data
				// auditStatus
			});
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},
		getNew(e) {
			if (e.target.value != this.form.newpassword) {
				this.pwOk = false
			} else {
				this.pwOk = true
			}
		},
		createCode() {
			const codeChars = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f',
				'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
				'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
				'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z');
			for (var i = 0; i < this.codeLength; i++) {
				var charNum = Math.floor(Math.random() * 62);
				this.code += codeChars[charNum];
			}
		},
		clearCode() {
			this.code = '';
			this.createCode()
		},

		exportExcelTemplate() {
			axios({
				methods: 'get',
				url: register_mp.exportExcelTemplate,
				responseType: 'blob',
				headers: {
					'content-type': 'application/x-www-form-urlencoded',
					Authorization: 'Bearer' + ls.get('token') || ''
				}
			}).then(data => {
				const blob = new Blob([data.data], { type: "application/docx" });
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement("a"); // 创建a标签
				link.href = url;
				link.download = decodeURIComponent('企业认证承诺授权书.docx');// 文件重命名，若无需重命名，将该行删去
				link.click();
				URL.revokeObjectURL(url); // 释放内存
			})
		},
		heckCode() {
			var inputCode = this.inputvalue;
			if (inputCode.length <= 0) {
				this.show = true
				this.showerror = false
			} else if (inputCode.toUpperCase() != this.code.toUpperCase()) {
				this.showerror = true
				this.show = false
				this.code = ''
				this.createCode();
				// this.inputvalue = "";
			} else {
				this.showerror = false
				this.show = false
			}
		},
		handleChange(e) {
			this.optionsTreeList = null
			this.companyShow = null
			if (e == '004') {
				this.companyShow = 1
			} else if (e == '005') {
				this.optionsTreeList = this.optionsMechanIsmTreeList
			} else if (e == '006') {
				this.optionsTreeList = this.optionsBaseTreeTreeList
			}
		},
		onSubmit() {
			this.heckCode();
				if (this.showerror == false && this.show == false) {
					this.$refs.ruleForm
						.validate()
						.then((values) => {
							this.confirmLoading = true;
							this.postAction({
								url: common.schedule,
								params: {
									mobilePhone: values.phoneNumber,
								}
							}
							).then((res) => {
								if(res==4){
									notification.error({
									message: '暂无此账号，请重新注册',
									style: {
										width: '400px',
										fontWeight: '600',
										marginLeft: `${-200}%`,
										marginTop: `${20}%`,
									}
								});
								}else if(res==0){
									notification.warning({
									message: '账号审核中，请耐心等待',
									style: {
										width: '400px',
										fontWeight: '600',
										marginLeft: `${-200}%`,
										marginTop: `${20}%`,
									}
								});
								}else if(res==1){
									notification.success({
									message: '账号已通过审核！请登录',
									style: {
										width: '400px',
										fontWeight: '600',
										marginLeft: `${-200}%`,
										marginTop: `${20}%`,
									}
								});
								}else if(res==2){
									notification.error({
									message: '审核未通过，请重新注册',
									style: {
										width: '400px',
										fontWeight: '600',
										marginLeft: `${-200}%`,
										marginTop: `${20}%`,
									}
								});
								}
								
								
								
								this.confirmLoading = false;
								// this.$router.push(this.redirectPath);
							}).catch((err) => {
								console.log(err, 'err')
								this.confirmLoading = false;
							})
						})
						.catch(() => {
						})
					}

		},
	},
	mounted() {
		this.createCode();
		// this.getDate()
		if (ls.get('token') && ls.get("refresh_token")) {
			this.user.userName = this.$ls.get('userName')
			this.user.phoneNumber = this.$ls.get('phoneNumber')
		}
		this.all_logo = this.$ls.get('all_logo');
	},
	beforeCreate() {
		// 修改背景色
		document.querySelector('body').setAttribute('style', 'background-color:#fff')
	}
	,
	beforeUnmount() {
		// 销毁背景色
		document.querySelector('body').removeAttribute('style')
	},
}
</script>
  
<style scoped lang="less">

.headerBox {
	width: 100%;
	height: 92px;
	background-color: #fff;

	.hearderContentBox {
		width: 1200px;
		margin: 0 auto;

		.titleBox {
			cursor: pointer;
			overflow: hidden;
			float: left;
			line-height: 92px;
			font-size: 30px;
			font-weight: bold;

			.logoBox {
				float: left;
				width: 73px;
				height: 66px;
				margin-right: 5px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.rightBox {
			float: right;
			display: flex;
			justify-content: space-around;
			line-height: 92px;
			font-size: 16px;

			a {
				font-weight: 600;
			}

			.loginBox {
				// float: left;
				cursor: pointer;
			}

			.loginBox:hover {
				color: #fc550b;
			}

			.lineBox {
				height: 18px;
				top: 36px;
			}

			.resigierBox {
				cursor: pointer;
				// float: left;
			}

			.resigierBox:hover {
				color: #fc550b;
			}
		}
	}
}

.bannerBox {
	position: relative;
	width: 100%;

	:deep(.ant-carousel) {
		position: relative;
		width: 100%;
	}

	.bannerImg {
		width: 100%;
		height: 282px;

		img {
			width: 100%;
			object-fit: cover;
			height: 280px;
		}
	}
}



.floatBox {
	width: 100%;

	.textBox {
		width: 100%;
		height: 250px;
		background-image: url('../../assets/img/resigter.jpg');
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;

		.text {
			font-size: 30px;
			color: #fff;
			font-weight: 700;
		}
	}

	.midBox {
		position: relative;
		width: 100%;
		min-height: 50vh;

		.midFloatBox {
			overflow: hidden;
			width: 1200px;
			height: 100%;
			padding: 18px 15px 25px;
			margin: -40px auto 40px auto;
			background-color: #fff;
			box-shadow: 0 10px 15px rgba(39, 69, 167, .2);
			border-radius: 5px;

			.breadBox {
				// width: 1200px;
				margin: 3px 0 15px;
				font-size: 16px;
			}

			.tabBox {
				overflow: hidden;
				width: 100%;
				min-height: calc(100vh - 400px);
				margin: 0 auto;

				.code {
					text-align: center;
					height: 30px;
					background: #e2e2e2;
					line-height: 30px;
					font-size: 24px;
				}

				.layout-header {
					background-color: #ffffff;
					height: auto;
					padding-top: 30px;
				}

				//
				//.layout-content {
				//  background: url(../assets/img/login-bg.png) center center no-repeat #ffffff;
				//  padding: 60px 0;
				//}

				.layout-footer {
					background-color: #ffffff;
				}

				.container {
					//width: 90%;
					//height: 80%;
					margin-left: auto;
					margin-right: auto;
					padding-top: 30px;
					//padding-top: 48%;
					//background: url(../assets/img/login-image.png) center center no-repeat;
					//background-size: 80%;

				}

				.login-form {
					width: 70%;
					margin: 40px auto;

					h3 {
						margin: 0 0 30px;
						position: relative;
						padding-left: 15px;

						span {
							position: absolute;
							left: 0;
							display: block;
							height: 60%;
							top: 20%;
							width: 4px;
							background: #1890ff;
						}
					}
					.btnBB{
						width: 300px;
						margin: 0 auto;
					}
					:deep(.ant-form-item-label > label){
						font-size: 16px;
					}
				}

				.ant-col-10 {
					margin-top: -43%;
					margin-left: 12%;
				}

				.title {
					font-size: 60px;
					font-weight: 500;
					margin: 40px 0;
				}



				.vcode-img {
					display: block;
					width: 100%;
					height: 50px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.login-img {
					display: block;
					width: 100%;
				}

			}
		}

	}
}

.footerBox {
	width: 100%;
	background-color: #333333;

	.footerContent {
		position: relative;
		margin: 0 auto;
		padding: 24px 0;
		width: 1200px;

		.firstLine {
			padding: 8px 0;
			font-size: 14px;
			color: #999;

			span {
				margin-right: 18px;
			}
		}

		.footCode {
			position: absolute;
			right: 0;
			bottom: 12%;
			text-align: center;

			.footEwm {
				margin-bottom: 8px;
			}

			.footEwmTitle {
				color: #999;
			}
		}
	}
}

:deep(.ant-list-lg .ant-list-item) {
	padding: 16px 8px;
}
</style>